export default "icons/delete.svg"